import { createStore, applyMiddleware, combineReducers } from 'redux';
import { thunk } from 'redux-thunk';
import { composeWithDevTools } from '@redux-devtools/extension';

// Reducers
import { authReducer } from './reducers/authReducers';
import { productListReducer, productDetailsReducer, productCreateReducer, productUpdateReducer, productDeleteReducer } from './reducers/productReducers';
import { categoryListReducer, categoryDetailsReducer, categoryCreateReducer, categoryUpdateReducer, categoryDeleteReducer } from './reducers/categoryReducers';
import { cartReducer } from './reducers/cartReducers';
import { orderCreateReducer, orderDetailsReducer, orderPayReducer, orderListMyReducer, orderListReducer, orderUpdateStatusReducer } from './reducers/orderReducers';

import { 
  inventoryTotalValueReducer,
  warehouseListReducer,      
  inventoryAlertsReducer,
  productInventorySummaryReducer,  
  warehouseProductDetailsReducer,
  inventoryTransactionReducer,
  inventoryTransactionsReducer   
} from './reducers/inventoryReducers';

import {
  profitAnalysisReducer,
  salesTrendsReducer,
  seasonalAnalysisReducer,
  productPerformanceReducer,
  inventoryHealthReducer,
  analyticsDashboardReducer
} from './reducers/analyticsReducers';

const reducer = combineReducers({
  auth: authReducer,
  productList: productListReducer,
  productDetails: productDetailsReducer,
  productCreate: productCreateReducer,
  productUpdate: productUpdateReducer,
  productDelete: productDeleteReducer,
  categoryList: categoryListReducer,
  categoryDetails: categoryDetailsReducer,
  categoryCreate: categoryCreateReducer,
  categoryUpdate: categoryUpdateReducer,
  categoryDelete: categoryDeleteReducer,
  cart: cartReducer,
  orderCreate: orderCreateReducer,
  orderDetails: orderDetailsReducer,
  orderPay: orderPayReducer,
  orderListMy: orderListMyReducer,
  orderList: orderListReducer,
  orderUpdateStatus: orderUpdateStatusReducer,
  inventoryTotalValue: inventoryTotalValueReducer,
  warehouseList: warehouseListReducer,
  inventoryAlerts: inventoryAlertsReducer,
  productInventorySummary: productInventorySummaryReducer,  
  warehouseProductDetails: warehouseProductDetailsReducer,
  inventoryTransaction: inventoryTransactionReducer,
  inventoryTransactions: inventoryTransactionsReducer,
  profitAnalysis: profitAnalysisReducer,
  salesTrends: salesTrendsReducer,
  seasonalAnalysis: seasonalAnalysisReducer,
  productPerformance: productPerformanceReducer,
  inventoryHealth: inventoryHealthReducer,
  analyticsDashboard: analyticsDashboardReducer
});

// Get cart from localStorage
const cartItemsFromStorage = localStorage.getItem('cartItems')
  ? JSON.parse(localStorage.getItem('cartItems'))
  : [];

// Get auth token from localStorage
const token = localStorage.getItem('token');

const initialState = {
  cart: { cartItems: cartItemsFromStorage },
  auth: { token }
};

const middleware = [thunk];

const store = createStore(
  reducer,
  initialState,
  composeWithDevTools(applyMiddleware(...middleware))
);

export default store;